import { ButtonHTMLAttributes  } from "react"

const ActionButton = ({ className, ...props }: ButtonHTMLAttributes<HTMLButtonElement>) => {

    return <button className={`action-button ${className ?? ''}`} {...props}/>
}

export default ActionButton